import React, { Component } from 'react';
import { connect } from 'react-redux';

import DashboardAlertsComponent from '../../components/purchase-dashboard/alerts';
import Purchase from '../../lib/purchase';
import Payment from '../../lib/payment';
import Membership from '../../lib/membership';
import {
  getCurrentPurchase,
  getCurrentUserMembership,
  getFailedMemberships,
  getShortMemberships,
  ifImOrg as ifImOrgSelector,
  ifImNotOrg as ifImNotOrgSelector,
} from '../../selectors/purchase-selector';
import {
  ALERT_DASHBOARD_INCOMPLETE_AFTER_REMOVE,
  ALERT_DASHBOARD_ORGANIZER_COVERED_SHARES,
  ALERT_DASHBOARD_MEMBERS_REMOVED,
  ALERT_DASHBOARD_REMINDERS_SENT,
  ALERT_DASHBOARD_AUTO_PILOT_DISABLED,
  ALERT_MUST_LOG_IN_TO_INVITE,
  ALERT_PURCHASE_SAVED,
  ALERT_WITHDRAW_FROM_PURCHASE,

  showAutoPilotModal,
  showMakeChangesModal,
  showInviteModal,
  showEditCommitModal as showCommitModal,
  showResolveIssuesModal,
  hideAlert
} from '../../actions/ui';

class DashboardAlerts extends Component {
  disableAlerts() {
    return Purchase.isCanceled(this.props.purchase.status);
  }

  render() {
    if (this.disableAlerts()) return null;

    return (
      <DashboardAlertsComponent {...this.props} />
    );
  }
}

const getOtherMembershipsWithIssues = (state) => {
  const currentMembership = getCurrentUserMembership(state);
  const failedMemberships = getFailedMemberships(state);
  const shortMemberships = getShortMemberships(state);

  if (!currentMembership) return [];

  return [...failedMemberships, ...shortMemberships]
    .filter(membership => membership.id !== currentMembership.id);
};

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);
  const isActive = Purchase.isActive(purchase.status);
  const isGroupFull = Purchase.isGroupFull(purchase);
  const isCompleted = Purchase.isCompleted(purchase);
  const isCommitDeadlineExpired = Purchase.isDateExpired(purchase.group.commitDeadline);
  const productMaxSlots = purchase.product.maxSlots;
  const groupMaxSlots = purchase.group.maxSlots;
  const canAddSlots = productMaxSlots ? (groupMaxSlots || 0) < productMaxSlots : true;
  const { currentPayment } = purchase;
  const currentOrLastPayment = Purchase.getCurrentOrLastPayment(purchase);
  const isPaymentExpired = currentPayment && Purchase.isPaymentExpired(currentPayment);
  const isPaymentProcessing = Payment.isAuthorized(currentOrLastPayment.status);
  const isCurrentPaymentActive = currentPayment && Payment.isActive(currentPayment.status);
  const { ui: { alerts } } = state;
  const currentMembership = getCurrentUserMembership(state);
  const otherMembershipsWithIssues = getOtherMembershipsWithIssues(state);
  const isMemberCommitted = currentMembership && Membership.isCommitted(currentMembership.status);
  const ifImOrg = ifImOrgSelector(state);
  const ifImNotOrg = ifImNotOrgSelector(state);

  const isAutoPilotDisabledAlertVisible = alerts[ALERT_DASHBOARD_AUTO_PILOT_DISABLED] && !purchase.autoPilotEnabled;
  const isEnableAutoPilotAlertVisible = ifImOrg(
    isActive && currentPayment &&  isCurrentPaymentActive && !isPaymentExpired &&
    !isGroupFull && !purchase.autoPilotEnabled && !isAutoPilotDisabledAlertVisible,
  );
  const isPurchaseSavedAlertVisible = alerts[ALERT_PURCHASE_SAVED] && isActive && isCurrentPaymentActive;

  return {
    purchase,
    otherMembershipsWithIssues,

    // Alerts for Organizer
    isCommitDeadlineExpireAlertVisible: ifImOrg(!isPaymentExpired && isCommitDeadlineExpired),
    isEnableAutoPilotAlertVisible,
    isMakePurchaseAlertVisible: ifImOrg(isActive && isGroupFull && !canAddSlots),
    isMakePurchaseOrEditAlertVisible: ifImOrg(isActive && isGroupFull && canAddSlots),
    isPurchaseExpiredAlertVisible: ifImOrg(isPaymentExpired),
    isContributorsWithIssuesAlertVisible: ifImOrg(otherMembershipsWithIssues.length > 0),
    isPaymentProcessingAlertVisible: ifImOrg(isPaymentProcessing),

    // Alerts for current membership
    isGroupFullForInviteeAlertVisible: !isMemberCommitted && ifImNotOrg(isActive && isGroupFull),
    isMembershipChargeFailedAlertVisible: isActive && currentMembership && currentMembership.failed,
    isShortMembershipAlertVisible: isActive && currentMembership && isMemberCommitted && currentMembership.short,

    // Alerts for non members
    isGroupCompletedAlertVisible: ifImNotOrg(isCompleted),

    // Alerts triggered by actions
    isPurchaseIncompleteAfterRemoveAlertVisible: alerts[ALERT_DASHBOARD_INCOMPLETE_AFTER_REMOVE],
    isOrganizerCoveredSharesAlertVisible: alerts[ALERT_DASHBOARD_ORGANIZER_COVERED_SHARES],
    isMembersRemovedAlertVisible: alerts[ALERT_DASHBOARD_MEMBERS_REMOVED],
    isMustBeLogedInToInviteVisible: alerts[ALERT_MUST_LOG_IN_TO_INVITE],
    isWithdrawalAlertVisible: alerts[ALERT_WITHDRAW_FROM_PURCHASE],
    isPurchaseSavedAlertVisible,
    isAutoPilotDisabledAlertVisible,

    // Alerts for resolve issues
    isEmailReminderSentAlertVisible: alerts[ALERT_DASHBOARD_REMINDERS_SENT],
  };
};

const mapDispatchToProps = {
  showAutoPilotModal,
  showMakeChangesModal,
  showInviteModal,
  showCommitModal,
  showResolveIssuesModal,
  hideWithdrawalAlert: () => hideAlert(ALERT_WITHDRAW_FROM_PURCHASE),
  hidePurchaseSavedAlert: () => hideAlert(ALERT_PURCHASE_SAVED)
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardAlerts);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/alerts.container.js